module.exports = __webpack_public_path__ + "static/media/LogoNIE.de6640cf.png";